import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import TextInput from '../../../pages/components/inputs/TextInput';
import { Icon, RSelect } from '../../Component';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { TENANT_PROMOTIONS_UPDATE_USSD_CODE_API } from '../../../api/api_data';
import { fail_edit_ussd_code, loading_edit_ussd_code, reset_edit_ussd_code, success_edit_ussd_code } from '../../../reducers/auth_tenant/edit_ussd_code_Slice';
import { UPDATE_USSD_ERROR_MSG, UPDATE_USSD_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { getSelectedOption, messageToast } from '../../../utils/Utils';
import * as app_consts from "../../../utils/app_consts";

const initialState = { current_code: "", new_code: "", gateway_url: "", name: "", status: "" };

const EditUSSDCodeSettingMondal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [page_data, setPageData] = useState([]);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [sent_data, setSentData] = useState(data);
 const [submit_loading, setSubmitLoading] = useState(false);
 const [submit_error, setSubmitError] = useState("");
 const [formData, setFormData] = useState(initialState);
 const [employee_data, setEmployeeData] = useState('');
 const [all_employees, setAllEmployees] = useState([]);

 useEffect(() => {
  setError("");
  setSubmitError("");
  setSentData(data);
  setOpen(isOpen);
  setFormData({ ...formData, current_code: data?.code, new_code: "", gateway_url: data?.gateway_url, name: data?.name, status: data?.status });
 }, [isOpen, data]);

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handleEditUssdCode = () => {
  setSubmitError('');
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_edit_ussd_code, success_edit_ussd_code, fail_edit_ussd_code, UPDATE_USSD_ERROR_MSG, UPDATE_USSD_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_PROMOTIONS_UPDATE_USSD_CODE_API}`, formData));
 };

 // Listener
 const edit_ussd_code_listener = useSelector((state) => state.edit_ussd_code.edit_ussd_code);

 useEffect(() => {
  if (edit_ussd_code_listener.status !== app_consts.IDLE)
  {
   if (edit_ussd_code_listener.status === app_consts.LOADING)
   {
    setSubmitLoading(true);
    setSubmitError("");
   } else
   {
    if (edit_ussd_code_listener.status === app_consts.FAIL)
    {
     setSubmitError(edit_ussd_code_listener.message);
     messageToast(edit_ussd_code_listener.message, app_consts.FAIL);
    } else if (edit_ussd_code_listener.status === app_consts.SUCCESS)
    {
     messageToast(UPDATE_USSD_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
     closeModal();
    }
    setSubmitLoading(false);
    dispatch(reset_edit_ussd_code());
   }
  }
 }, [edit_ussd_code_listener]);

 const status_array = [
  {
   label: "Active",
   value: "active"
  },
  {
   label: "Disabled",
   value: "disabled"
  }
 ];

 return (
  <>
   <Modal isOpen={open} toggle={submit_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
    <ModalHeader toggle={submit_loading || loading ? "" : closeModal}>Edit USSD Code {sent_data ? sent_data?.code : "--"}</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="Current Code"
       type="text"
       id_val="current_code"
       value={sent_data?.code}
       colSize="6"
       required
       name="current_code"
       disabled
      />
      <TextInput
       label="Name"
       type="text"
       id_val="name"
       value={formData?.name}
       colSize="6"
       required
       name="name"
       handleChange={handleChange}
      />
      <TextInput
       label="Gateway URL"
       type="text"
       id_val="gateway_url"
       value={formData?.gateway_url}
       colSize="6"
       required
       name="gateway_url"
       handleChange={handleChange}
      />
      <TextInput
       label="New Code"
       type="text"
       id_val="new_code"
       value={formData?.new_code}
       colSize="6"
       required
       name="new_code"
       handleChange={handleChange}
      />
      <Col size={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="ussd_code">
         Status<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div >
         <RSelect
          options={status_array}
          placeholder="Search"
          id="ussd_code"
          onChange={(e) => {
           setFormData({ ...formData, status: e.value });
          }}
          value={getSelectedOption(formData?.status, status_array)}
         />
        </div>
       </div>
      </Col>
      {submit_error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {submit_error}{" "}
        </Alert>
       </div>
      )}
      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
       <Button onClick={handleEditUssdCode} disabled={submit_loading || !(formData?.name && formData?.new_code && formData?.gateway_url && formData?.current_code && formData?.status)} color="primary">
        {submit_loading ? <Spinner size="sm" color="light" /> : "Edit USSD Code"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default EditUSSDCodeSettingMondal;